module.exports = __webpack_public_path__ + "static/img/instagram.fe7c8574.svg";